import { Modal, Result, Space, Spin, Typography, theme } from 'antd';
import type { ReactNode } from 'react';
import React from 'react';
import styles from './DestinationContentGenerationModal.module.css';

const { Text } = Typography;

type DestinationContentGenerationModalProps = Readonly<{
    title: string;
    subTitle: string;
    icon: ReactNode;
}>;

export function DestinationContentGenerationModal({ title, subTitle, icon }: DestinationContentGenerationModalProps) {
    const { token } = theme.useToken();

    return (
        <Modal open closable={false} maskClosable={false} keyboard={false} footer={null} centered width={440}>
            <Result
                icon={
                    <div
                        className={styles.iconBadge}
                        style={{
                            backgroundColor: token.colorPrimaryBg,
                            color: token.colorPrimary,
                        }}>
                        {icon}
                    </div>
                }
                title={title}
                subTitle={subTitle}
                extra={
                    <Space className={styles.progress} align='start' size={8}>
                        <Spin size='small' />
                        <Text type='secondary'>This might take a while, please don’t close this page.</Text>
                    </Space>
                }
            />
        </Modal>
    );
}
